import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isRtlLanguage } from '../i18n/languages';

/** Syncs document lang/dir when the active locale changes. */
const LanguageSync: React.FC = () => {
    const { i18n } = useTranslation();

    useEffect(() => {
        const apply = (lng: string) => {
            const code = lng.split('-')[0];
            document.documentElement.lang = code;
            document.documentElement.dir = isRtlLanguage(code) ? 'rtl' : 'ltr';
        };

        apply(i18n.resolvedLanguage || i18n.language);
        i18n.on('languageChanged', apply);
        return () => {
            i18n.off('languageChanged', apply);
        };
    }, [i18n]);

    return null;
};

export default LanguageSync;
